import I18n from "../../../../../../core/localization/I18n";
import { CommentListViewModel } from "../../../../../change/comments/commentListView/CommentListView_model";
import { RevisionHistoryModel } from "../../../../../change/revisionHistory/RevisionHistory_model";
import { CardProps } from "../../../view/components/KanbanBoard/KanbanBoard";
import ActionsApi, { ActionsApi as IActionsApi } from "../../../../../../services/api/v2/actions/Actions.api";
import { ActionField } from "../../../../../../enums";
import { action } from "mobx";

export class PerspectiveModalModel {
  orgId: number;
  projectId: number;
  commentViewModel: CommentListViewModel;
  action: CardProps;
  revisionHistoryModel: RevisionHistoryModel;
  actionsProvider: IActionsApi;
  /**
   *
   */
  constructor(orgId: number, projectId: number, authUser, action: CardProps) {
    this.orgId = orgId;
    this.projectId = projectId;
    this.action = action;
    this.actionsProvider = ActionsApi;

    this.commentViewModel = new CommentListViewModel(projectId, authUser, {
      placeholderText: I18n.t("placeholders.actionNotePlaceholder"),
      searchAttribute: "actionId",
      id: action.id,
      title: null,
      projectId: this.projectId,
      organisationId: this.orgId
    });

    this.revisionHistoryModel = new RevisionHistoryModel({
      entityId: this.action.id,
      projectId: this.projectId,
      historyType: "actions",
      organisationId: this.orgId
    });
  }

  @action
  updateProgressStatus = async (selectedProgressStatus: number) => {
    await this.actionsProvider.updateField(
      this.orgId,
      this.projectId,
      this.action.id,
      "",
      selectedProgressStatus,
      null,
      0,
      ActionField.progressStatus
    );
  };
}
